import React from "react";

const Service = () => {
  return (
    <div class="card bg-dark text-white mb-4 pb-4 border-white">
      <div class="card-body">
        <h5 class="card-title">UI/UX Design</h5>
        <p class="card-text text-muted">3 years experience</p>
        <p class="card-text">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt
          inventore minus sint unde perspiciatis sed. Nulla nam molestiae animi
          doloribus.
        </p>
        <a href="#!" class="btn btn-outline-light">
          Go somewhere
        </a>
      </div>
    </div>
  );
};

export default Service;
